import * as React from "react";
import * as ReactDOM from "react-dom";
import { classNames } from "src/services/theme";

interface Props {
    open?: boolean;
    className?: string;
    toggler?: string;
    backdrop?: boolean;
    icon?: string | null;
    iconImg?: string | null;
    title?: string | null;
    onOpen?: Function;
    onClose?: Function;
}

interface State {
    open: boolean;
}

export default class Modal extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            open: props.open || false
        };
    }
    
    toggle() {
        const { onOpen, onClose } = this.props;
        const newOpen = !this.state.open;
        this.setState({
            open: newOpen
        });
        if (newOpen && onOpen) {
            onOpen();
        }
        if (!newOpen && onClose) {
            onClose();
        }
    }
  
    render() {
        const { children, className = '', toggler, backdrop, icon, iconImg, title } = this.props;
        const { open } = this.state;
        console.log(this.props)
        
        return (
            <>
            {open &&
            <ModalComponent className={classNames(className, (icon || iconImg) ? 'wicon' : null, (title) ? 'wtitle' : null)}>
                <div className="modal-backdrop fade in" />
                <div className="modal"
                    style={{display: "block"}}
                    onClick={(e) => { if (backdrop && (e.target as any).className === "modal") { this.toggle(); } } }
                >
                    <div className="modal-dialog">
                        {icon &&
                        <div className="modal-icon">
                            <span className={`icon-${icon}`} />
                        </div>
                        }
                        {iconImg &&
                        <div className="modal-icon-img">
                            <span className="fit">
                                <img src={iconImg} />
                            </span>
                        </div>
                        }
                        <div className="modal-close" onClick={() => this.toggle()}>
                            <span className="icon-close" />
                        </div>
                        <div className="modal-content">
                            {title &&
                            <div className="modal-header">
                                <h4 className="modal-title">{title}</h4>
                            </div>
                            }
                        {children}
                        </div>
                    </div>
                </div>
            </ModalComponent>
            }
            {toggler &&
            <span onClick={() => this.toggle()} dangerouslySetInnerHTML={{__html: toggler}} />
            }
            </>
        );
    }
}

const modalRoot = document.getElementsByTagName('body')[0];
const modalClass = 'modal-open';
class ModalComponent extends React.Component<any, any> {
    private el;

    constructor(props) {
        super(props);
        this.el = document.createElement('div');
        this.el.className = 'UI_Modal ' + props.className;
    }

    componentDidMount() {
        modalRoot.className += ' ' + modalClass;
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        modalRoot.className = modalRoot.className.replace(modalClass, "");
        modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/Modal.tsx